<template>
  <section class="card_style">
    <div class="main_header_style">
      <h5 class="mb-4">{{ $t("facility") }}</h5>
    </div>

    <form @submit.prevent="addFacilities()">
      <div class="row mb-5 mt-3">
        <div class="col-lg-6">
          <label>{{ $t("arabic") }}</label>
          <input
            type="text"
            :placeholder="$t('enter bed name')"
            v-model="bedName_ar"
          />
        </div>
        <div class="col-lg-6">
          <label>{{ $t("english") }}</label>
          <input
            type="text"
            :placeholder="$t('enter bed name')"
            v-model="bedName_en"
          />
        </div>
        <div class="col-lg-6">
          <label>{{ $t("icon") }}</label>
          <Multiselect
            v-model="icon"
            :options="icons"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            :placeholder="$t('choose')"
          />
        </div>
      </div>

      <button
        type="submit"
        class="edit save btn"
        :disabled="!bedName_ar || !bedName_en"
      >
        {{ $t("edit") }}
      </button>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      bedId: this.$route.params.id,
      bedName_ar: "",
      bedName_en: "",

      icon: "",
      icons: ["services", "reception", "wifi", "somke", "lift"],
    };
  },
  methods: {
    fetchBedData() {
      axios
        .post(`/show_room_facilities`, {
          room_facilities_id: this.$route.params.id,
        })
        .then(({ data }) => {
          data.data.title.forEach((element) => {
            if (element.locale == "ar") {
              this.bedName_ar = element.title;
            }
            if (element.locale == "en") {
              this.bedName_en = element.title;
            }
          });

          this.icon = data.data.icon;
        });
    },
    addFacilities() {
      if (this.$route.params.id == undefined) {
        axios
          .post(`/store_room_facilities`, {
            title_en: this.bedName_en,
            title_ar: this.bedName_ar,
            icon: this.icon,
          })
          .then(({ data }) => {
            Swal.fire({
              title: "",
              text: data.message,
              icon: "success",
            });
            this.$router.push("/room-facilities");
          })
          .catch((error) => {
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: "error",
            });
          });
      } else {
        axios
          .post(`/update_room_facilities`, {
            room_facilities_id: this.$route.params.id,
            title_en: this.bedName_en,
            title_ar: this.bedName_ar,
            icon: this.icon,
          })
          .then(({ data }) => {
            Swal.fire({
              title: "",
              text: data.message,
              icon: "success",
            });
            this.$router.push("/room-facilities");
          })
          .catch((error) => {
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: "error",
            });
          });
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.fetchBedData();
    }
    // this.fetchBedData();
    localStorage.removeItem("flightData");
    localStorage.removeItem("flightTrips");
    localStorage.removeItem("bookDataFlight");
    localStorage.removeItem("bookDetails");
    localStorage.removeItem("hotelData");
    localStorage.removeItem("bookData");
  },
};
</script>

<style lang="scss" scoped>
@import "../_crudStyle.scss";
</style>
